var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMonday = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 66,
  height: 40,
  viewBox: "0 0 66 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_4298_3989)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M33.1003 39.5243C30.2575 39.4553 27.9121 38.2095 26.4144 35.6092C24.8794 32.9211 24.9462 30.1694 26.5829 27.5477C30.4794 21.3084 34.4268 15.1037 38.35 8.88295C39.1523 7.61065 39.9359 6.31976 40.7757 5.07137C41.8905 3.36388 43.6323 2.15606 45.6304 1.7051C47.6284 1.25413 49.7248 1.59565 51.4731 2.65693C55.1663 4.91731 56.4019 9.6187 54.1019 13.324C49.4004 20.9295 44.6321 28.4977 39.7969 36.0288C38.3072 38.3583 36.0474 39.4818 33.1003 39.5243Z",
  fill: "#FFCB00"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.68353 39.5243C5.81396 39.4553 3.48193 38.1537 2.01371 35.564C0.500029 32.876 0.596306 30.1189 2.23835 27.4973C6.42995 20.8179 10.6403 14.1483 14.8693 7.48847C15.4042 6.62787 15.939 5.74603 16.5113 4.912C17.6719 3.24158 19.4414 2.08531 21.4452 1.68801C23.4491 1.2907 25.53 1.68354 27.2473 2.78336C28.9647 3.88318 30.1836 5.60363 30.6461 7.58046C31.1086 9.55728 30.7784 11.6353 29.7253 13.3745C25.0398 20.8888 20.2902 28.3765 15.5379 35.8562C13.9948 38.2812 11.7243 39.4818 8.68353 39.5243Z",
  fill: "#FF3D57"
}), /*#__PURE__*/React.createElement("path", {
  d: "M57.6749 24.2939C61.9993 24.3152 65.5 27.7283 65.492 31.9144C65.492 36.1643 61.8977 39.5907 57.5331 39.5376C53.1686 39.4845 49.7294 36.1085 49.7347 31.9038C49.7401 27.638 53.2542 24.2674 57.6749 24.2939Z",
  fill: "#00D647"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_4298_3989"
}, /*#__PURE__*/React.createElement("rect", {
  width: 65,
  height: 40,
  fill: "white",
  transform: "translate(0.5)"
})))));
export { SvgMonday as ReactComponent };
export default __webpack_public_path__ + "static/media/monday.0f15608f.svg";